import React, { Component } from "react";
import { Flex, Box, Spinner } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroller";
import { Monitoring } from "src/modules/activity-log/monitoring-info";
import { H4 } from "src/atoms/typography";
import ScrollBox from "src/atoms/ScrollBox/index";
import time from "src/utils/time";
import MonitoringItem from "./MonitoringItem";

function getFormattedDate(startDateObj, t) {
  const now = time();
  const currentYear = now.year();
  const currentMonth = now.month();
  const isFromThisYear = startDateObj.year() === currentYear;
  const isFromThisMonth = startDateObj.month() === currentMonth;

  if (isFromThisMonth && isFromThisYear) {
    return t("activityLog.monitoringsList.thisMonth");
  } else if (isFromThisYear) {
    return time.monthName(startDateObj);
  } else return `${time.monthName(startDateObj)}, ${startDateObj.year()}`;
}

class MonitoringsList extends Component {
  selectedMonitoringBoxRef = React.createRef();
  scrollTimeoutId = null;

  componentDidMount() {
    const { monitorings, selectedMonitoringId } = this.props;
    const selectedMonitoringBox = this.selectedMonitoringBoxRef.current;

    if (
      selectedMonitoringBox &&
      monitorings[0].uniqueId !== selectedMonitoringId
    ) {
      this.scrollTimeoutId = setTimeout(
        () => selectedMonitoringBox.scrollIntoView({ block: "center" }),
        50
      );
    }
  }
  componentWillUnmount() {
    clearTimeout(this.scrollTimeoutId);
  }

  render() {
    const {
      monitorings,
      selectedMonitoringId,
      onSelect,
      hasMoreMonitorings,
      loadMore,
      onDelete,
      t
    } = this.props;
    let lastPushedMonth = null;
    let lastPushedYear = null;
    const listItems = [];

    monitorings.forEach((monitoring) => {
      const { startDate, duration, uniqueId } = monitoring;
      const startDateObj = time(startDate);
      if (
        startDateObj.month() !== lastPushedMonth ||
        startDateObj.year() !== lastPushedYear
      ) {
        const dateToDisplay = getFormattedDate(startDateObj, t);
        listItems.push(
          <H4
            color="highEmphasis"
            key={dateToDisplay}
            mb="8px"
            mt="24px"
            pl="24px"
          >
            {dateToDisplay}
          </H4>
        );
        lastPushedMonth = startDateObj.month();
        lastPushedYear = startDateObj.year();
      }
      listItems.push(
        <Box
          ref={
            uniqueId === selectedMonitoringId
              ? this.selectedMonitoringBoxRef
              : null
          }
          key={uniqueId}
          pl="8px"
          pr="4px"
        >
          <MonitoringItem
            onDelete={onDelete}
            startDate={startDate}
            duration={duration}
            onSelect={() => onSelect(uniqueId)}
            isSelected={uniqueId === selectedMonitoringId}
            isShared={Monitoring.isShared(monitoring)}
          />
        </Box>
      );
    });
    return (
      <ScrollBox pb="16px">
        <InfiniteScroll
          loadMore={loadMore}
          hasMore={hasMoreMonitorings}
          loader={
            <Flex key="loader" pt="12px" justifyContent="center">
              <Spinner />
            </Flex>
          }
          useWindow={false}
          initialLoad={false}
        >
          {listItems}
        </InfiniteScroll>
      </ScrollBox>
    );
  }
}

export default withTranslation()(MonitoringsList);
